import get from 'lodash/get'

import { theme } from '@/ui/theme/theme'

export const getColorFromHexOrConst = (color: string) => {
  // color format is e.g. "green-primary" or "#fff"
  const isHex = color.startsWith('#')

  return isHex ? color : get(theme.colors, color.replace('-', '.'), 'inherit')
}
